import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class SayacMarkaListeAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "SayacMarkaListe";
        super(baseUrl);
    }
    getSayacMarkaListe() {

        return this.get("", false);
    }
}
export default new SayacMarkaListeAPI();